import moment from "moment";

export const elementMatches = (el, selector) => {
  return (el.matches || el.matchesSelector || el.msMatchesSelector || el.mozMatchesSelector || el.webkitMatchesSelector || el.oMatchesSelector).call(el, selector);
};

export const elementMatchesAny = (el, selectorArray) => {
  for (let idx = 0; idx < selectorArray.length; idx++) {
    let v = selectorArray[idx];
    if (elementMatches(el, v) || el.parentElement.closest(v)) {
      return true;
    }
  }
  return false;
};

export const groupBy = function (xs, key) {
  return xs.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};

export const validateEmailFormat = function (val) {
  var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regex.test(val.toLowerCase());
};

export const getByPath = function (path, val) {
  return path.split(".").reduce((p, c) => p?.[c] || null, val);
};

export const getDateTime = function (date) {
  return moment(date).format("YYYY-MM-DDTHH:mm:ss") + "Z";
};

export const downloadBlob = function (blob, filename) {
  var url = window.URL.createObjectURL(blob);
  var a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
};

export const flattenByKey = function (arr, key) {
  return arr ? arr.reduce((r, i) => [...r, i, ...flattenByKey(i[key], key)], []) : [];
};

export const flattenElements = function (data) {
  return data.reduce((r, { children, ...rest }) => {
    r.push(rest);
    if (children) r.push(...flattenElements(children));
    return r;
  }, []);
};

export const findRecursive = function (array, predicate) {
  var result;
  array.some((o) => (predicate(o) && (result = o)) || (result = findRecursive(o.children ?? [], predicate)));
  return result;
};

export const formatTime = function (time) {
  if (time.toString().length <= 3) return "0" + time.toString().slice(0, 1) + ":" + (time.toString().length === 1 ? "00" : time.toString().slice(1, 4));
  else return time.toString().slice(0, 2) + ":" + time.toString().slice(2, 4);
};